import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=2cd6a844&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=2cd6a844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd6a844",
  null
  
)

export default component.exports